<template>
  <div class="box8">
    <pageTitle
      title="AI智能开发<br/>下一代技术人才的标配"
      text="掌握AI智能开发范式，提前锁定未来十年的技术竞争力"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="box8__content">
      <img
        class="box8__illustration"
        src="../../../assets/coursePage/llm/box8/illustration.png"
        alt=""
      />

      <div class="box8__features">
        <div class="feature">
          <h3 class="feature__name feature__name--gradient">OpenClaw</h3>
          <p class="feature__subtitle">AI时代智能体开发框架</p>
          <p class="feature__desc">
            让AI自动完成适配企业真实场景的全流程工作
          </p>
        </div>

        <img
          class="box8__plus"
          src="../../../assets/coursePage/llm/box8/icon-plus.png"
          alt=""
        />

        <div class="feature">
          <h3 class="feature__name feature__name--gradient">Vibe Coding</h3>
          <p class="feature__subtitle">AI时代人机协作核心开发范式</p>
          <p class="feature__desc">
            指挥AI写代码、查bug、<br />多角色协同，让AI为你所用
          </p>
        </div>
      </div>
    </div>

    <ConsultBtn text="测一测我能不能学" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box8 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 40px;
    margin-top: 14px;
  }

  &__content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    margin-top: 48px;
  }

  &__illustration {
    flex-shrink: 0;
    width: 292px;
    height: 564px;
    object-fit: contain;
  }

  &__features {
    flex: 1;
    min-width: 0;
    margin-left: 32px;
    padding-top: 32px;
  }

  &__plus {
    display: block;
    width: 48px;
    height: 48px;
    margin: 32px 0 32px 62px;
    object-fit: contain;
  }

  .feature {
    &__name {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 36px;
      font-weight: 700;
      line-height: 54px;

      &--gradient {
        .llm-text-gradient();
        display:inline;
      }
    }

    &__subtitle {
      margin: 14px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #072557;
      line-height: 40px;
    }

    &__desc {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;
    }
  }

}
</style>
